module.exports = __webpack_public_path__ + "static/assets/f96b6684e734168c54300dcffa16850f.svg";